export type ChatSdkModule = typeof import("@origin-digital/chat-client-sdk");

export const loadChatSdk = (): Promise<ChatSdkModule> =>
  import("@origin-digital/chat-client-sdk");
